import * as React from "react";
import { FC } from "react";
import { Feature } from "ol";
import { MapContextProvider } from "../Contexts/MapContext";
import { MapDownloadContextProvider } from "../Contexts/MapDownloadContext";
import { Info } from "../Popups/Info/Info";
import { Toast } from "../Elements/Toast";
import { GeoLiteMap } from "../Map/GeoLiteMap";
import "../css/icons/style.css";
import "../css/map.scss";
import "../css/App.scss";
import "ol/ol.css";

export interface IMapProps {
    features: Feature[] | null;
    forceUpdate: number;
}

export const MapProvider: FC = () => {
    return (
        <>
            <MapContextProvider>
                <MapDownloadContextProvider>
                    <GeoLiteMap></GeoLiteMap>
                    {/* {info ? <Info></Info> : null} */}
                </MapDownloadContextProvider>
            </MapContextProvider>

            <Toast />

            {/* this is for cluster label width measuring */}
            <div id="hiddenLabel"></div>
        </>
    );
};
